import { render, staticRenderFns } from "./addClassify.vue?vue&type=template&id=26fb009f&scoped=true&"
import script from "./addClassify.vue?vue&type=script&lang=ts&"
export * from "./addClassify.vue?vue&type=script&lang=ts&"
import style0 from "./addClassify.vue?vue&type=style&index=0&id=26fb009f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26fb009f",
  null
  
)

export default component.exports